import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import NotificationCounter from '@wix/da-ds/pkg/Indicators/NotificationCounter';
import LlamaIcon from '@wix/da-ds/pkg/Icons/Llama';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './FakeNotification.scss';
var FakeNotification = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['notification'] },
        React.createElement("div", { className: s['notification-icon'] },
            React.createElement(LlamaIcon, { size: IconSize.SMALL })),
        React.createElement("div", { className: s['notification-content'] },
            React.createElement("div", { className: s['notification-text'] }, t('siteHeader.anonFakeNotifications.notification.text')),
            React.createElement("div", { className: s['notification-timestamp'] }, t('siteHeader.anonFakeNotifications.notification.timestamp')),
            React.createElement("div", { className: s['notification-action'] },
                React.createElement(SolidButton, { href: Url.joinLink(), variant: "approval-green", size: "small", className: s['notification-button'] }, t('siteHeader.anonFakeNotifications.notification.action')))),
        React.createElement("div", { className: s['notification-counter'] },
            React.createElement(NotificationCounter, null, "1"))));
};
FakeNotification.displayName = 'FakeNotification';
export default FakeNotification;
//# sourceMappingURL=FakeNotification.js.map